import Directory from "../Directory/directory.component";

const Category = () => {
  return (
    <>
      <Directory />
    </>
  );
};

export default Category;
